import React from 'react';

interface IProps {
  containerClassName?: string;
  firstDivClassName?: string;
  secondDivClassName?: string;
  firstDivValue?: string | number | React.ReactNode;
  secondDivValue?: string | number | React.ReactNode;
  spanClassName?: string;
  spanText?: string;
  linkRef?: string;
  linkedText?: string;
  linkClassName?: string;
  firstDivId?: string;
  secondDivId?: string;
}

const TwoDivsInOne = ({
  containerClassName, firstDivClassName, secondDivClassName, firstDivValue, secondDivValue, spanText, linkRef, linkedText, linkClassName, spanClassName, firstDivId, secondDivId,
}:IProps) => (
  <div className={containerClassName}>
    {firstDivValue && <div id={`${firstDivId ?? 'firstDivId'}`} className={firstDivClassName}>{firstDivValue}</div>}
    {secondDivValue && <div id={`${secondDivId ?? 'secondDivId'}`} className={secondDivClassName}>{secondDivValue}</div>}
    {linkRef && linkedText && spanText && (
    <span className={spanClassName}>
      {spanText}
      <a id={`link-to-${linkRef}`} className={linkClassName} href={linkRef}>{linkedText}</a>
    </span>
    )}
  </div>
);

export default TwoDivsInOne;
